import React, { useRef, useEffect, useState } from 'react';
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2';

ChartJS.register(ArcElement, Tooltip, Legend);

const Chart = ({ centerDetails, courseDetails, auth }) => {
  const chartContainerRef = useRef(null);
  const [chartSize, setChartSize] = useState(300); // Default chart size

  useEffect(() => {
    const handleResize = () => {
      // Adjust chart size based on container width
      if (chartContainerRef.current) {
        const containerWidth = chartContainerRef.current.offsetWidth;
        setChartSize(containerWidth * 0.8); // Set chart size to 80% of container width
      }
    };

    window.addEventListener('resize', handleResize);
    handleResize(); // Initial size setting

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const label = (auth.userType==='Superadmin' || auth.userType==='Accounts'||auth.userType==='Manager')
    ? centerDetails.map(todo => todo.vtp_id)
    : courseDetails.map(todo => todo.course_code);

  const mainData = (auth.userType==='Superadmin' || auth.userType==='Accounts'||auth.userType==='Manager')
    ? centerDetails.map(todo => todo.Total_Batches)
    : courseDetails.map(todo => todo.Total_Batches);

  const data = {
    labels: label,
    datasets: [
      {
        label: 'No. of Batches',
        data: mainData,
        backgroundColor: [
          "rgba(153, 102, 255, 0.2)", // Lavender
          "rgba(255, 215, 0, 0.2)",  // Gold
          "rgba(0, 128, 128, 0.2)",  // Teal
          "rgba(255, 69, 0, 0.2)",   // Orange Red
          "rgba(0, 100, 0, 0.2)",    // Dark Green
          "rgba(106, 90, 205, 0.2)", // Slate Blue
          "rgba(255, 99, 132, 0.2)", // Light Red
          "rgba(54, 162, 235, 0.2)", // Light Blue
          "rgba(255, 159, 64, 0.2)", // Light Orange
          "rgba(75, 0, 150, 0.2)",   // Indigo
        ],
        borderColor: [
          "rgba(153, 102, 255, 1)",   // Lavender
          "rgba(255, 215, 0, 1)",    // Gold
          "rgba(0, 128, 128, 1)",    // Teal
          "rgba(255, 69, 0, 1)",     // Orange Red
          "rgba(0, 100, 0, 1)",      // Dark Green
          "rgba(106, 90, 205, 1)",   // Slate Blue
          "rgba(255, 99, 132, 1)",   // Light Red
          "rgba(54, 162, 235, 1)",   // Light Blue
          "rgba(255, 159, 64, 1)",   // Light Orange
          "rgba(75, 0, 150, 1)",     // Indigo 
        ],
        borderWidth: 1,
        hoverOffset: 20, // Increase size on hover
      }
    ],
  };

  return (
    <div
      ref={chartContainerRef}
      className="w-full max-w-lg mx-auto p-4"
      style={{ height: `${chartSize}px`, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
    >
      <Doughnut
        data={data}
        options={{
          maintainAspectRatio: false,
          responsive: true,
        }}
        style={{ maxHeight: '100%', maxWidth: '100%' }}
      />
    </div>
  );
};

export default Chart;
